/* eslint-disable @typescript-eslint/no-unused-vars */
import { usePrepareImage } from '~/hooks/usePrepareImage'

import { useNavigation } from '~/context/Navigation'

import { FileInputButton } from '~/components/FileInputButton'

import { translate } from '~/utils/translate'

import * as Styled from './styles'
import { ProcessingImageErrorFeedback } from '../../components/ProcessingImageErrorFeedback'
import { validateAvatarImageFile } from '../../utils/validateAvatarImageFile'

export const ImageInputProcessingFailure = () => {
  const { navigate, params } = useNavigation()
  const { convertToBase64 } = usePrepareImage()

  const handleOnChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event?.target?.files?.length) return

    const file = event.target.files[0]

    validateAvatarImageFile(file)

    const result = await convertToBase64(file)

    localStorage.setItem('@doris_candidate_avatar', result)

    navigate('ImageInputProcessing')
  }

  return (
    <Styled.Container data-testid="image-input-processing-failure-screen">
      <ProcessingImageErrorFeedback />
      <FileInputButton
        icon="imageUpload"
        name="avatar-upload"
        onChange={handleOnChange}
        accept=".heic, .png, .jpg, .jpeg"
      >
        {translate('IMAGE_INPUT_PROCESSING_RETRY_BUTTON')}
      </FileInputButton>
    </Styled.Container>
  )
}
